module.exports = __webpack_public_path__ + "static/media/28pic.b2002f74.jpg";